import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AccountingApi } from '_api';
import { handleError, handleResponse } from '_helpers/api';

export const getMeetings = createAsyncThunk(
  'meetings/getMeetings',
  async function ({ customerId }, { rejectWithValue }) {
    try {
      const response = await AccountingApi.getMeetings({ customerId });
      return handleResponse(response);
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

const meetingsSlice = createSlice({
  name: 'meetings',
  initialState: {
    data: [],
    error: null,
    loading: false,
    fetchCounter: 0,
  },
  reducers: {
    resetData(state) {
      state.data = [];
    },
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMeetings.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getMeetings.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.fetchCounter += 1;
      })
      .addCase(getMeetings.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { resetData, resetError } = meetingsSlice.actions;

export default meetingsSlice.reducer;
